module.exports = __webpack_public_path__ + "static/img/2.b9a7a5a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/20/zh/2.png
// module id = 9yx+
// module chunks = 0